import dayjs from "dayjs";
import { toUtcYmd } from "@/utils/hall-slot-matches-raza-event-date";
import type { HouseVisitSlotRecord } from "../../types";
import type { HouseVisitSlotCalendarEvent } from "./types";

export function slotStopCount(row: HouseVisitSlotRecord): number {
  return row.stopCount ?? row._count?.stops ?? row.stops?.length ?? 0;
}

export function mapHouseVisitSlotRowToCalendarEvent(
  row: HouseVisitSlotRecord
): HouseVisitSlotCalendarEvent | null {
  const ymd = toUtcYmd(row.date);
  if (!ymd) return null;

  // Local midnight for the calendar day (matches react-big-calendar dayjs localizer).
  const day = dayjs(ymd);
  if (!day.isValid()) return null;

  const capacity = Number(row.capacity ?? 0) || 10;
  const stops = slotStopCount(row);
  const fillRatio = capacity > 0 ? Math.min(1, stops / capacity) : 0;
  const label = row.label?.trim();
  const title = label || `${stops}/${capacity} stops`;
  const subTitle = label ? `${stops}/${capacity} stops` : undefined;

  return {
    id: row.id,
    title,
    subTitle,
    start: day.startOf("day").toDate(),
    end: day.endOf("day").toDate(),
    allDay: true,
    fillRatio,
    stopCount: stops,
    capacity,
    resource: row,
  };
}

export function mapHouseVisitSlotRowsToCalendarEvents(
  rows: unknown[]
): HouseVisitSlotCalendarEvent[] {
  return (rows as HouseVisitSlotRecord[])
    .map(mapHouseVisitSlotRowToCalendarEvent)
    .filter((e): e is HouseVisitSlotCalendarEvent => e != null);
}
